/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

import { MODELS } from '../../../../../Apis/Models';
import {
    AccessDevicesTitle,
    BuildingModalIcon,
    CompletePersonChip,
    IconBuildingTable,
    IconForkKnifeCard,
    IconPeronClock,
    IconTraffic,
    IconUnderReview,
    OutlinedCalendarIcon,
    PhoneLight,
    SystemSettings,
    IconAirplane,
    IconChart,
    IconDeleteTicket,
    IconDocumentPencil,
    IconDocumentVehicle,
    IconHomeScreen,
    IconMapMarket,
    IconServer,
    IconSpeaker,
    IconTelescope,
    EmailSubsectionChip,
    IconPersonPlusCard,
    IconVehicle,
    IconUserAuthority,
    IconChipMultiplePerson,
    IconChipDepartment,
    IconCard,
    IconEntryDevice,
    DescriptionTittle,
    IconCalendarPaid,
    PlusIconsOptions,
    IconKitchenTickets,
    IconGuardTitle,
    TicketChip,
    UserDocumentIcon,
    IconKitchenTicket,
    logisticIcon,
    DocumentationIcon,
} from '../../../../../components/buttons/IconButtons';
import { IconsSideBar } from '../../../SideBars/Functionality/IconsSideBar';
import { EMPTY_VALUES } from '../../../../../Apis/functions';
import { IconsMenuCard } from '../../../../LoginOption/Functionality/IconsMenuCard';

// These IDs represent the specific modules that are accessible on the app
export const allowedModuleIdsApp = [1, 5, 4, 3, 2, 17, 20, 46, 53, 92];
// These IDs represent the specific modules that are accessible on the web platform
export const allowedModuleIdsWeb = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 23, 26, 27, 28, 29, 30, 31, 32, 33, 34,
    35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64,
    65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 97, 98,
    99, 100, 101, 102,
];
// Step indexes for creating a new role
export const STEPS_CREATE_NEW_ROLE = {
    SET_UP_PRIVILEGES: 0,
    ASSIGN_EMPLOYEES: 1,
    SUMMARY: 2,
};
// Available platforms for privilege assignment
export const privilegesPlatforms = [
    {
        id: 'mobile',
        translation: 'mobile',
        icon: <PhoneLight />,
    },
    {
        id: 'web',
        translation: 'website',
        icon: <AccessDevicesTitle />,
    },
];
// Available tab options for platform selection
export const TAB_OPTIONS = {
    MOBILE: 'mobile',
    WEB: 'web',
};
// Step indexes for updating an existing role
export const STEPS_ROLES_UPDATE = {
    PRIVILEGES: 0,
    EMPLOYEES: 1,
};
export const WEBSITE_ROLES_MODEL = [
    {
        id: MODELS.Company,
        translation: 'company',
        icon: IconBuildingTable,
        children: [
            {
                id: MODELS.Company,
                translation: 'company',
            },
        ],
    },
    {
        id: MODELS.Profile,
        translation: 'profile',
        icon: CompletePersonChip,
        children: [
            {
                id: MODELS.Profile,
                translation: 'profile',
            },
        ],
    },
    {
        id: MODELS.Announcement,
        translation: 'announcement',
        icon: IconSpeaker,
        children: [
            {
                id: MODELS.Announcement,
                translation: 'announcement',
            },
        ],
    },
    {
        id: MODELS.Employee,
        translation: 'employees',
        icon: IconChipMultiplePerson,
        children: [
            {
                id: MODELS.Employee,
                translation: 'employee',
            },
        ],
    },
    {
        id: MODELS.Contractor,
        translation: 'contractors',
        icon: IconDocumentPencil,
        children: [
            {
                id: MODELS.Contractor,
                translation: 'contractors',
            },
            {
                id: MODELS.CONTRACTOR_MANAGE,
                translation: 'manage',
            },
            {
                id: MODELS.CONTRACTOR_APPROVAL_FLOW,
                translation: 'approval_flow',
            },
        ],
    },
    {
        id: MODELS.Supplier,
        translation: 'suppliers',
        icon: UserDocumentIcon,
        children: [
            {
                id: MODELS.Supplier,
                translation: 'supplier',
            },
            {
                id: MODELS.SUPPLIER_APPROVAL_FLOW,
                translation: 'approval_flow',
            },
            {
                id: MODELS.SUPPLIER_MANAGE,
                translation: 'manage',
            },
        ],
    },
    {
        id: MODELS.WorkShift,
        translation: 'work_shift',
        icon: CompletePersonChip,
        children: [
            {
                id: MODELS.WorkShift,
                translation: 'work_shift',
            },
        ],
    },
    {
        id: MODELS.Privilege,
        translation: 'privilege',
        icon: IconUserAuthority,
        children: [
            {
                id: MODELS.Privilege,
                translation: 'privilege',
            },
        ],
    },
    {
        id: MODELS.Zone,
        translation: 'first_access',
        icon: IconsSideBar.icFirstAccess,
        children: [
            {
                id: MODELS.Zone,
                translation: 'first_access',
            },
        ],
    },
    {
        id: MODELS.Devices,
        translation: 'devices',
        icon: AccessDevicesTitle,
        children: [
            {
                id: MODELS.Devices,
                translation: 'devices',
            },
        ],
    },
    {
        id: MODELS.Reports,
        translation: 'reports',
        icon: TicketChip,
        children: [
            {
                id: MODELS.Reports,
                translation: 'reports',
            },
        ],
    },
    {
        id: MODELS.BackUp,
        translation: 'back_up',
        icon: IconServer,
        children: [
            {
                id: MODELS.BackUp,
                translation: 'back_up',
            },
        ],
    },
    {
        id: MODELS.HomeOffice,
        translation: 'home_office',
        icon: IconHomeScreen,
        children: [
            {
                id: MODELS.HomeOffice,
                translation: 'home_office',
            },
        ],
    },
    {
        id: MODELS.Onboarding,
        translation: 'onboarding',
        icon: IconPersonPlusCard,
        children: [
            {
                id: MODELS.Onboarding,
                translation: 'onboarding',
            },
        ],
    },
    {
        id: MODELS.EmailSettings,
        translation: 'email_settings',
        icon: EmailSubsectionChip,
        children: [
            {
                id: MODELS.EmailSettings,
                translation: 'email_settings',
            },
        ],
    },
    {
        id: MODELS.vehicle,
        translation: 'vehicle',
        icon: IconVehicle,
        children: [
            {
                id: MODELS.vehicle,
                translation: 'vehicle',
            },
        ],
    },
    {
        id: MODELS.UserAccessLog,
        translation: 'user_access_log',
        icon: CompletePersonChip,
        children: [
            {
                id: MODELS.UserAccessLog,
                translation: 'user_access_log',
            },
        ],
    },
    {
        id: MODELS.VehicleAccessLog,
        translation: 'vehicle_access_log',
        icon: IconDocumentVehicle,
        children: [
            {
                id: MODELS.VehicleAccessLog,
                translation: 'vehicle_access_log',
            },
        ],
    },
    {
        id: MODELS.Department,
        translation: 'department',
        icon: IconChipDepartment,
        children: [
            {
                id: MODELS.Department,
                translation: 'department',
            },
        ],
    },
    {
        id: MODELS.Holliday,
        translation: 'holiday',
        icon: IconAirplane,
        children: [
            {
                id: MODELS.Holliday,
                translation: 'holiday',
            },
        ],
    },
    {
        id: MODELS.CardDesigner,
        translation: 'card_managment',
        icon: IconCard,
        children: [
            {
                id: MODELS.Card,
                translation: 'card_management',
            },
            {
                id: MODELS.CardDesigner,
                translation: 'card_designer',
            },
        ],
    },
    {
        id: MODELS.Resource,
        translation: 'resource',
        icon: DocumentationIcon,
        children: [
            {
                id: MODELS.Resource,
                translation: 'resource',
            },
        ],
    },
    {
        id: MODELS.LogInLog,
        translation: 'login_log',
        icon: IconEntryDevice,
        children: [
            {
                id: MODELS.LogInLog,
                translation: 'login_log',
            },
        ],
    },

    {
        id: MODELS.LogAction,
        translation: 'log_action',
        icon: DescriptionTittle,
        children: [
            {
                id: MODELS.LogAction,
                translation: 'log_action',
            },
        ],
    },
    {
        id: MODELS.HID,
        translation: 'hid',
        icon: IconsSideBar.icControllerSubmenu,
        children: [
            {
                id: MODELS.HID,
                translation: 'hid',
            },
        ],
    },
    {
        id: MODELS.CHART,
        translation: 'chart',
        icon: IconChart,
        children: [
            {
                id: MODELS.CHART,
                translation: 'chart',
            },
        ],
    },
    {
        id: MODELS.HARD_DELETE,
        translation: 'hard_delete',
        icon: IconDeleteTicket,
        children: [
            {
                id: MODELS.HARD_DELETE,
                translation: 'hard_delete',
            },
        ],
    },
    {
        id: MODELS.SYSTEM_CONFIG,
        translation: 'system_settings',
        icon: SystemSettings,
        children: [
            {
                id: MODELS.SYSTEM_CONFIG,
                translation: 'system_settings',
            },
        ],
    },
    {
        id: MODELS.APPROVAL_FLOW,
        translation: 'approval_flows',
        icon: IconUnderReview,
        children: [
            {
                id: MODELS.APPROVAL_FLOW,
                translation: 'approval_flows',
            },
        ],
    },
    {
        id: MODELS.FOODIE,
        translation: 'dining',
        icon: IconForkKnifeCard,
        children: [
            {
                id: MODELS.FOODIE_SHIFT,
                translation: 'shifts',
            },
            {
                id: MODELS.FOODIE_MEAL_TIME,
                translation: 'service_time',
            },
            {
                id: MODELS.FOODIE_ACCESS,
                translation: 'access_codes',
            },
            {
                id: MODELS.FOODIE_CAFETERIA,
                translation: 'cafeterias',
            },
            {
                id: MODELS.FOODIE_MENU,
                translation: 'menus',
            },
            {
                id: MODELS.FOODIE_MEAL_FORECAST,
                translation: 'meal_forecast',
            },
            {
                id: MODELS.FOODIE_ITEM,
                translation: 'meals',
            },
            {
                id: MODELS.INGREDIENT,
                translation: 'ingredients',
            },
            {
                id: MODELS.FOODIE_REQUEST,
                translation: 'request',
            },
            {
                id: MODELS.FOODIE,
                translation: 'foodie',
            },
            {
                id: MODELS.FOODIE_SETTING,
                translation: 'settings',
            },
            {
                id: MODELS.FOODIE_DEPARTMENT_POLICIES,
                translation: 'department_policies',
            },
            {
                id: MODELS.TOTAL_MEALS,
                translation: 'total_meals',
            },
            {
                id: MODELS.FOODIE_USER_MENU_SELECTION,
                translation: 'orders',
            },
            {
                id: MODELS.FOODIE_EXTRA_REQUEST,
                translation: 'request_meals',
            },
        ],
    },
    {
        id: MODELS.KITCHEN_TICKETS,
        translation: 'kitchen_tickets',
        icon: IconKitchenTicket,
        children: [
            {
                id: MODELS.KITCHEN_TICKETS,
                translation: 'orders',
            },
            {
                id: MODELS.KITCHEN_TICKETS_HISTORY,
                translation: 'history',
            },
        ],
    },
    {
        id: MODELS.Invitation,
        translation: 'visitor_management',
        icon: BuildingModalIcon,
        children: [
            {
                id: MODELS.VISITOR_INVITATION,
                translation: 'invitations',
            },

            {
                id: MODELS.VISITOR_REQUEST,
                translation: 'request',
            },
            {
                id: MODELS.VISITOR,
                translation: 'visitor',
            },
            {
                id: MODELS.REQUEST_ACCESS,
                translation: 'active_request',
            },
            {
                id: MODELS.VISITOR_TYPE,
                translation: 'types',
            },
        ],
    },
    {
        id: MODELS.LOGISTIC_REQUEST,
        translation: 'logistics',
        icon: IconTelescope,
        children: [
            {
                id: MODELS.SERVICE_TYPE,
                translation: 'service_type',
            },
            {
                id: MODELS.DISTRIBUTION_CENTER,
                translation: 'distribution_center',
            },
            {
                id: MODELS.LOGISTIC_REQUEST,
                translation: 'transport_request',
            },
        ],
    },
    {
        id: MODELS.Event,
        translation: 'reservations',
        icon: OutlinedCalendarIcon,
        children: [
            {
                id: MODELS.Event,
                translation: 'reservation_status',
            },
            {
                id: MODELS.EVENT_STATUS,
                translation: 'status',
            },
            {
                id: MODELS.EVENT_MANAGE,
                translation: 'manage',
            },
        ],
    },
    {
        id: MODELS.FINE,
        translation: 'traffic_fine_system',
        icon: IconTraffic,
        children: [
            {
                id: MODELS.TRAFFIC_USERS,
                translation: 'user_fines',
            },
            {
                id: MODELS.TRAFFIC_DASHBOARD_FINES,
                translation: 'fines',
            },
            {
                id: MODELS.TRAFFIC_MANAGE_FINES,
                translation: 'fine_managment',
            },
            {
                id: MODELS.TRAFFIC_MANAGE_GEOFENCES,
                translation: 'geofence_management',
            },
            {
                id: MODELS.FINE_TYPE,
                translation: 'fine_types',
            },
        ],
    },
    {
        id: MODELS.Attendance,
        translation: 'attendance',
        icon: IconPeronClock,
        children: [
            {
                id: MODELS.Attendance,
                translation: 'attendance',
            },
            {
                id: MODELS.ATTENDANCE_SHIFT,
                translation: 'shifts_access',
            },
            {
                id: MODELS.ATTENDANCE_SETTING,
                translation: 'settings',
            },
            {
                id: MODELS.ATTENDANCE_DEPARTMENT_POLICIES,
                translation: 'department_policies',
            },
        ],
    },
    {
        id: MODELS.Guard,
        translation: 'guard',
        icon: IconGuardTitle,
        children: [
            {
                id: MODELS.Guard,
                translation: 'guard',
            },
        ],
    },
];

export const MOBILE_ROLES_MODEL = [
    {
        id: MODELS.Company,
        translation: 'company',
        icon: IconBuildingTable,
        children: [
            {
                id: MODELS.Company,
                translation: 'company',
            },
        ],
    },
    {
        id: MODELS.Profile,
        translation: 'profile',
        icon: CompletePersonChip,
        children: [
            {
                id: MODELS.Profile,
                translation: 'profile',
            },
        ],
    },
    {
        id: MODELS.Announcement,
        translation: 'announcement',
        icon: IconSpeaker,
        children: [
            {
                id: MODELS.Announcement,
                translation: 'announcement',
            },
        ],
    },
    {
        id: MODELS.Event,
        translation: 'reservation_request',
        icon: OutlinedCalendarIcon,
        children: [
            {
                id: MODELS.Event,
                translation: 'reservation_request',
            },
        ],
    },
    {
        id: MODELS.Invitation,
        translation: 'invitations',
        icon: IconCalendarPaid,
        children: [
            {
                id: MODELS.Invitation,
                translation: 'invitations',
            },
        ],
    },
    {
        id: MODELS.Devices,
        translation: 'devices',
        icon: AccessDevicesTitle,
        children: [
            {
                id: MODELS.Devices,
                translation: 'devices',
            },
        ],
    },
    {
        id: MODELS.FINE,
        translation: 'traffic_fine_system',
        icon: IconTraffic,
        children: [
            {
                id: MODELS.FINE,
                translation: 'traffic_fine_system',
            },
        ],
    },
    {
        id: MODELS.HomeOffice,
        translation: 'shifts',
        icon: IconHomeScreen,
        children: [
            {
                id: MODELS.HomeOffice,
                translation: 'shifts',
            },
        ],
    },
];

export const modulesPermission = {
    [MODELS.Company]: 'company',
    [MODELS.Invitation]: 'invitation',
    [MODELS.Event]: 'event',
    [MODELS.Announcement]: 'announcement',
    [MODELS.Profile]: 'profile',
    [MODELS.Contractor]: 'contractor',
    [MODELS.Supplier]: 'supplier',
    [MODELS.Log]: 'log',
    [MODELS.Employee]: 'employee',
    [MODELS.EmployeeCompanyDocument]: 'employee_company_document',
    [MODELS.SupplierCompanyDocument]: 'supplier_company_document',
    [MODELS.SupplierVehicleCompanyDocument]: 'supplier_vehicle_company_document',
    [MODELS.WorkShift]: 'work_shift',
    [MODELS.Privilege]: 'privilege',
    [MODELS.Zone]: 'zone',
    [MODELS.Devices]: 'devices',
    [MODELS.Reports]: 'reports',
    [MODELS.BackUp]: 'backup',
    [MODELS.HomeOffice]: 'home_office',
    [MODELS.Onboarding]: 'onboarding',
    [MODELS.Hospitality]: 'hospitality',
    [MODELS.EmailSettings]: 'email_settings',
    [MODELS.User]: 'user',
    [MODELS.vehicle]: 'vehicle',
    [MODELS.UserAccessLog]: 'user_access_log',
    [MODELS.VehicleAccessLog]: 'vehicle_access_log',
    [MODELS.DocumentsForContractor]: 'documents_for_contractor',
    [MODELS.DocumentsForContractorVehicles]: 'documents_for_contractor_vehicles',
    [MODELS.Department]: 'department',
    [MODELS.Contract]: 'contract',
    [MODELS.Order]: 'order',
    [MODELS.Holliday]: 'holiday',
    [MODELS.Attendance]: 'attendance',
    [MODELS.Card]: 'card',
    [MODELS.CardDesigner]: 'card_designer',
    [MODELS.Resource]: 'resource',
    [MODELS.ContractorEmployee]: 'contractor_employee',
    [MODELS.ContractorVehicle]: 'contractor_vehicle',
    [MODELS.SupplierEmployee]: 'supplier_employee',
    [MODELS.SupplierVehicle]: 'supplier_vehicle',
    [MODELS.LogInLog]: 'login_log',
    [MODELS.LogAction]: 'log_action',
    [MODELS.Guard]: 'guard',
    [MODELS.HID]: 'hid',
    [MODELS.HIDInput]: 'hid_input',
    [MODELS.HIDOutput]: 'hid_output',
    [MODELS.HIDSio]: 'hid_sio',
    [MODELS.HIDReader]: 'hid_reader',
    [MODELS.SYSTEM_CONFIG]: 'system_config',
    [MODELS.HARD_DELETE]: 'hard_delete',
    [MODELS.CHART]: 'chart',
    [MODELS.FOODIE]: 'foodie',
    [MODELS.APPROVAL_FLOW]: 'approval_flow',
    [MODELS.VISITOR_TYPE]: 'visitor_type',
    [MODELS.INGREDIENT]: 'ingredient',
    [MODELS.FOODIE_ITEM]: 'foodie_item',
    [MODELS.FOODIE_MENU]: 'foodie_menu',
    [MODELS.FOODIE_CAFETERIA]: 'foodie_cafeteria',
    [MODELS.FOODIE_SHIFT]: 'foodie_shift',
    [MODELS.SERVICE_TYPE]: 'service_type',
    [MODELS.DISTRIBUTION_CENTER]: 'distribution_center',
    [MODELS.LOGISTIC_REQUEST]: 'logistic_request',
    [MODELS.FOODIE_USER_MENU_SELECTION]: 'foodie_user_menu_selection',
    [MODELS.FOODIE_EXTRA_REQUEST]: 'foodie_extra_request',
    [MODELS.FOODIE_MEAL_TIME]: 'foodie_meal_time',
    [MODELS.FOODIE_DEPARTMENT_POLICIES]: 'foodie_department_policies',
    [MODELS.VISITOR_INVITATION]: 'visitor_invitation',
    [MODELS.VISITOR_REQUEST]: 'visitor_request',
    [MODELS.VISITOR]: 'visitor',
    [MODELS.KITCHEN_TICKETS]: 'kitchen_tickets',
    [MODELS.KITCHEN_TICKETS_HISTORY]: 'kitchen_tickets_history',
    [MODELS.FOODIE_REQUEST]: 'foodie_request',
    [MODELS.REQUEST_ACCESS]: 'request_access',
    [MODELS.VISITOR_INCOMING_INVITATION]: 'visitor_incoming_invitation',
    [MODELS.TOTAL_MEALS]: 'total_meals',
    [MODELS.FOODIE_MEAL_FORECAST]: 'foodie_meal_forecast',
    [MODELS.FOODIE_ACCESS]: 'foodie_access',
    [MODELS.FINE_TYPE]: 'fine_type',
    [MODELS.TRAFFIC_DASHBOARD_GEOFENCES]: 'traffic_dashboard_geofences',
    [MODELS.TRAFFIC_DASHBOARD_FINES]: 'traffic_dashboard_fines',
    [MODELS.TRAFFIC_USERS]: 'traffic_users',
    [MODELS.TRAFFIC_MANAGE_FINES]: 'traffic_manage_fines',
    [MODELS.TRAFFIC_MANAGE_GEOFENCES]: 'traffic_manage_geofences',
    [MODELS.EVENT_STATUS]: 'event_status',
    [MODELS.CONTRACTOR_APPROVAL_FLOW]: 'contractor_approval_flow',
    [MODELS.EVENT_MANAGE]: 'event_manage',
    [MODELS.CONTRACTOR_MANAGE]: 'contractor_manage',
    [MODELS.SUPPLIER_APPROVAL_FLOW]: 'supplier_approval_flow',
    [MODELS.SUPPLIER_MANAGE]: 'supplier_manage',
    [MODELS.FINE]: 'fine',
    [MODELS.EQUIPMENT_MATERIAL]: 'equipment_material',
    [MODELS.EQUIPMENT_ACCESS_LOG]: 'equipment_access_log',
    [MODELS.ATTENDANCE_SHIFT]: 'attendance_shift',
    [MODELS.ATTENDANCE_SETTING]: 'attendance_setting',
    [MODELS.ATTENDANCE_DEPARTMENT_POLICIES]: 'attendance_department_policies',
    [MODELS.KITCHEN_ACCESS]: 'kitchen_access',
    [MODELS.KITCHEN_ACCESS_HISTORY]: 'kitchen_access_history',
    [MODELS.FOODIE_SETTING]: 'foodie_setting',
    [MODELS.PILGRIMS_MEAL_TIME_REPORT]: 'pilgrims_meal_time_report',
    [MODELS.PILGRIMS_ACCESS_REPORT]: 'pilgrims_access_report',
};
// Supported permission actions
export const actions = ['read', 'create', 'update', 'delete', 'export', 'import', 'cancel', 'recover', 'menu'];

// Returns the module name associated with a module ID
export const getModuleName = (moduleId) => {
    return modulesPermission[moduleId] || EMPTY_VALUES.DEFAULT;
};

// Formats a permission name into a readable header label
export const formatPermissionHeader = (permissionName) => {
    return permissionName
        ?.split('_')[0]
        ?.toLowerCase()
        ?.replace(/\b\w/g, (char) => char.toUpperCase());
};

// Converts underscore-separated text into title case
export const formatColumnTitle = (text) => {
    return text
        ?.toLowerCase()
        ?.split('_')
        ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        ?.join(' ');
};

export const EMPLOYEE_TAB = {
    ADD_EMPLOYEES: {
        key: 'ADD_EMPLOYEES',
        translation: 'add_employees',
        icon: <PlusIconsOptions />,
    },
    ASSIGNED_EMPLOYEES: {
        key: 'ASSIGNED_EMPLOYEES',
        translation: 'assigned_employees',
        icon: <IconChipMultiplePerson />,
    },
};
export const SPECIAL_PERMISSIONS = [
    'WEB_VCARD_SETTINGS_UPDATE',
    'WEB_HEADERS_UPDATE',
    'WEB_USER_RESTRICTION_UPDATE',
    'WEB_SUPPLIER_ORDER_READ',
    'WEB_SUPPLIER_ORDER_UPDATE',
    'WEB_SUPPLIER_ORDER_DELETE',
    'WEB_SUPPLIER_ORDER_CREATE',
    'WEB_SUPPLIER_ORDER_EXPORT',
    'WEB_VISITOR_INVITATION_STATUS_DOCUMENTATION_READ',
    'WEB_VISITOR_INVITATION_STATUS_IDENTIFY_READ',
    'WEB_CONTRACTOR_INCOMING_READ',
    'WEB_DEVICE_RESTRICTION_UPDATE',

];

export const ROLE_MODEL = {
    roleName: '',

    isValid: function () {
        return this.roleName.trim() !== '';
    },

    toRegister: function () {
        return {
            name: this.roleName,
        };
    },
    set: function (data) {
        return {
            ...this,
            roleName: data?.name || '',
        };
    },

    clear: function () {
        this.roleName = '';
        return this;
    },
};
export const ROLE_RESTRICTION_MODEL = {
    biocrValidation: false,
    eventValidation: false,
    extraDataEmployee: false,
    id: '',
    roleId: '',
    keepSessionActiveWebApp: false,
    sharePdfInMobileApp: false,
    useTokenWebApp: false,

    set: function (data) {
        return {
            ...this,
            id: data?.id || '',
            roleId: data?.roleId || '',
            biocrValidation: data?.biocrValidation || false,
            eventValidation: data?.eventValidation || false,
            extraDataEmployee: data?.extraDataEmployee || false,
            keepSessionActiveWebApp: data?.keepSessionActiveWebApp || false,
            sharePdfInMobileApp: data?.sharePdfInMobileApp || false,
            useTokenWebApp: data?.useTokenWebApp || false,
        };
    },

    toRegister: function () {
        return {
            roleId: this.roleId,
            id: this.id,
            biocrValidation: this.biocrValidation,
            eventValidation: this.eventValidation,
            extraDataEmployee: this.extraDataEmployee,
            keepSessionActiveWebApp: this.keepSessionActiveWebApp,
            sharePdfInMobileApp: this.sharePdfInMobileApp,
            useTokenWebApp: this.useTokenWebApp,
        };
    },

    clear: function () {
        return { ...ROLE_RESTRICTION_MODEL };
    },
};

export const EMPLOYEE_CONFIG_MODEL = {
    keyId: 'userId',
    resourceString: 'EMPLOYEE',
    labelRowsPerPage: 'employees_per_page',
    tableNotInformationLegend: 'no_employees_assigned',
    searchLabel: 'search',
    title_modal: 'remove_employees',
    element_modal: 'employees',

    set: function (custom = {}) {
        return {
            keyId: custom?.keyId || this.keyId,
            resourceString: custom?.resourceString || this.resourceString,
            labelRowsPerPage: custom?.labelRowsPerPage || this.labelRowsPerPage,
            tableNotInformationLegend: custom?.tableNotInformationLegend || this.tableNotInformationLegend,
            searchLabel: custom?.searchLabel || this.searchLabel,
            title_modal: custom?.title_modal || this.title_modal,
            element_modal: custom?.element_modal || this.element_modal,
            renderAssignedItem: custom?.renderAssignedItem,
        };
    },
};

export const CREATE_UPDATE_ROLE_MODEL = {
    id: '',
    addTasks: [],
    removeTasks: [],
    name: '',
    roleRestriction: {},

    set: function (data) {
        return {
            ...this,
            ...data,
        };
    },

    toRegister: function (data) {
    return {
        id: data?.id,
        addTasks: data?.addTasks,
        removeTasks: data?.removeTasks,
        name: data?.name?.trim(),
        roleRestriction: data?.roleRestriction,
    };
},
};
